export default __webpack_public_path__ + "static/media/outside-employment-activities.62bd58c3.svg";